import { Component, Input } from '@angular/core';

@Component({
  selector: 'context-diff',
  template: require('./diff-context.component.html'),
})
export class DiffContextComponent {
  @Input() lines: any[];

  constructor() {
    // constructor logic, if needed
  }
}
